import { Warehouse, Container, Wheat, Zap, ArrowUpRight } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { SERVICES } from "@/lib/data";
import { useI18n } from "@/context/LanguageContext";

const ICONS = { Warehouse, Container, Wheat, Zap };

export const Services = () => {
  const { t } = useI18n();
  return (
    <section id="services" className="bg-offwhite py-16 sm:py-20 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <Reveal>
          <SectionLabel index="/ 01">{t.labels.services}</SectionLabel>
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
            <h2 className="font-display font-700 uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] text-charcoal max-w-2xl">
              {t.services.heading[0]} <span className="text-safety">{t.services.heading[1]}</span> {t.services.heading[2]}
            </h2>
            <p className="text-charcoal/60 max-w-sm text-base">
              {t.services.sub}
            </p>
          </div>
        </Reveal>

        <div className="grid lg:grid-cols-6 gap-5 auto-rows-[minmax(0,1fr)]">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            const ti = t.services.items[i];
            const big = i === 0;
            return (
              <Reveal key={s.no} delay={i * 0.08} className={s.span}>
                <div
                  data-testid={`service-card-${i}`}
                  className="group relative h-full min-h-[300px] bg-white border-2 border-charcoal overflow-hidden hover:-translate-y-1 transition-transform duration-200"
                >
                  <div className={`absolute inset-0 ${big ? "" : "opacity-0"} `}>
                    <img src={s.img} alt={s.title} className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-charcoal/70" />
                  </div>
                  {!big && (
                    <img
                      src={s.img}
                      alt={s.title}
                      className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                    />
                  )}
                  {!big && <div className="absolute inset-0 bg-transparent group-hover:bg-charcoal/75 transition-colors duration-500" />}

                  <div className="relative h-full p-7 flex flex-col justify-between">
                    <div className="flex items-start justify-between">
                      <span className={`font-mono2 text-sm font-700 ${big ? "text-safety" : "text-charcoal group-hover:text-safety"} transition-colors`}>
                        {s.no}
                      </span>
                      <div className={`w-12 h-12 border-2 flex items-center justify-center transition-colors ${big ? "border-safety text-safety" : "border-charcoal text-charcoal group-hover:border-safety group-hover:text-safety"}`}>
                        <Icon size={22} />
                      </div>
                    </div>

                    <div>
                      <h3 className={`font-display font-700 uppercase text-2xl lg:text-3xl leading-none mb-3 ${big ? "text-white" : "text-charcoal group-hover:text-white"} transition-colors`}>
                        {ti.title}
                      </h3>
                      <p className={`text-sm leading-relaxed mb-4 max-w-md ${big ? "text-white/70" : "text-charcoal/60 group-hover:text-white/70"} transition-colors`}>
                        {ti.desc}
                      </p>
                      <div className="flex flex-wrap gap-2">
                        {ti.tags.map((t2) => (
                          <span
                            key={t2}
                            className={`font-mono2 text-[10px] uppercase tracking-wider px-2.5 py-1 border ${big ? "border-white/30 text-white/80" : "border-charcoal/30 text-charcoal/70 group-hover:border-white/30 group-hover:text-white/80"} transition-colors`}
                          >
                            {t2}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                  <ArrowUpRight
                    size={20}
                    className={`absolute top-7 right-7 opacity-0 ${big ? "text-safety" : "text-safety"} group-hover:opacity-100 transition-opacity`}
                  />
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
